import { render, staticRenderFns } from "./v-button.vue?vue&type=template&id=25a09720&scoped=true&"
import script from "./v-button.vue?vue&type=script&lang=ts&"
export * from "./v-button.vue?vue&type=script&lang=ts&"
import style0 from "./v-button.vue?vue&type=style&index=0&id=25a09720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a09720",
  null
  
)

export default component.exports